import React, { useLayoutEffect, useRef } from 'react';
import { array, func, number, oneOf, string } from 'prop-types';
import cn from 'classnames';
import anime from 'animejs/lib/anime.es.js';
import styles from './Revealer.module.scss';
import { handleAnimationProgressCbs } from '../../../utils/animationHelpers';

function Revealer(props) {
  const {
    className,
    position,
    background,
    easing,
    duration,
    delay,
    keyframes,
    onAnimationUpdate,
    onAnimationEnd,
    onUnmount,
    onProgress,
  } = props;
  const ref = useRef();

  useLayoutEffect(() => {
    const progressHandler = handleAnimationProgressCbs(onProgress);

    // schedules a new macrotask to avoid possible significant flickering
    // and non-stable animation on the initial load
    setTimeout(() => {
      anime({
        duration,
        delay,
        easing,
        keyframes,
        targets: ref.current,
        update(anim) {
          progressHandler(anim);
          onAnimationUpdate?.(anim);
        },
        complete: onAnimationEnd,
      });
    }, 0);
    return () => {
      onUnmount?.();
    };
  }, []);

  return (
    <div
      ref={ref}
      className={cn(styles.revealer, {
        [className]: !!className,
      })}
      style={{
        position,
        background,
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 999,
      }}
    />
  );
}

Revealer.propTypes = {
  position: oneOf(['fixed', 'absolute']),
  background: string,
  easing: string,
  duration: number,
  delay: number,
  keyframes: array,
  onUnmount: func,
};

Revealer.defaultProps = {
  position: 'fixed',
  duration: 750,
  delay: 50,
  keyframes: [{ clipPath: 'inset(0 0 0 0)' }, { clipPath: 'inset(0 0 100% 0)' }],
  easing: 'easeOutQuad',
  background: '#000',
};

export default Revealer;
